import { Link } from "react-router-dom";

export const WCButton = ({
  as = "button",
  to,
  href,
  filled = false,
  disabled = false,
  children,
  className = "",
  onClick,
  type = "button",
  ...rest
}) => {
  const cls = `wc-btn ${filled ? "wc-btn--filled" : ""} ${disabled ? "wc-btn--disabled" : ""} ${className}`;
  if (as === "link" && to) {
    return (
      <Link to={to} className={cls} onClick={onClick} {...rest}>
        {children}
      </Link>
    );
  }
  if (as === "a" && href) {
    return (
      <a href={href} className={cls} onClick={onClick} {...rest}>
        {children}
      </a>
    );
  }
  return (
    <button type={type} className={cls} onClick={onClick} disabled={disabled} {...rest}>
      {children}
    </button>
  );
};

export default WCButton;
